module.exports = __webpack_public_path__ + "img/bg_function05_1_d.6f090819.svg";